import api from "./api";

async function fetchQueries(query, { signal } = {}) {
  const queryString = query ? `?${query}` : "";
  const response = await api.get(`api/queries${queryString}`, { signal });
  return response.data;
}

async function updateQueryStatus(id, status, { resolutionReason, resolutionComment } = {}) {
  const response = await api.patch(`api/queries/${id}/status`, { status, resolutionReason, resolutionComment });
  return response.data;
}

async function assignQuery(id, { assignedToUserId, assignedToName }) {
  const response = await api.patch(`api/queries/${id}/assign`, { assignedToUserId, assignedToName });
  return response.data;
}

async function updateQueryDetails(id, details) {
  const response = await api.patch(`api/queries/${id}/details`, { details });
  return response.data;
}

async function fetchQueryReasons({ signal } = {}) {
  const response = await api.get("api/queries/reasons", { signal });
  return response.data;
}

async function fetchQueryReasonSettings({ signal } = {}) {
  const response = await api.get("api/queries/reasons/settings", { signal });
  return response.data;
}

async function addQueryReason(label) {
  const response = await api.post("api/queries/reasons", { label });
  return response.data;
}

async function renameQueryReason(id, label) {
  const response = await api.patch(`api/queries/reasons/${id}`, { label });
  return response.data;
}

async function deleteQueryReason(id) {
  await api.delete(`api/queries/reasons/${id}`);
}

async function fetchQueryDetail(id, { signal } = {}) {
  const response = await api.get(`api/queries/${id}`, { signal });
  return response.data;
}

async function fetchQueryAnalytics({ signal } = {}) {
  const response = await api.get("api/queries/analytics", { signal });
  return response.data;
}

async function createQuery({ ledgerTransactionIds, lineItems, reason, details, assignedToUserId, assignedToName, priority, attachments }) {
  const response = await api.post("api/queries", {
    ledgerTransactionIds,
    lineItems,
    reason,
    details,
    assignedToUserId,
    assignedToName,
    priority,
    attachments,
  });
  return response.data;
}

async function uploadQueryAttachment(file) {
  const form = new FormData();
  form.append("file", file);
  const response = await api.post("api/queries/attachments", form);
  return response.data;
}

export {
  fetchQueries,
  updateQueryStatus,
  fetchQueryReasons,
  fetchQueryReasonSettings,
  addQueryReason,
  renameQueryReason,
  deleteQueryReason,
  fetchQueryDetail,
  fetchQueryAnalytics,
  createQuery,
  uploadQueryAttachment,
  assignQuery,
  updateQueryDetails,
};
